import { Fragment, useMemo } from 'react';

import { getUuid } from '@kc-console/core';

import DetailViewSectionContainer from './DetailViewSectionContainer';
import DetailViewTabs from './DetailViewTabs';

import type { DetailViewProps } from './types';

/**
 * [ DetailLayout 하위 DetailSection의 children에서 사용하는 컴포넌트 ]
 *
 * - 콘솔 상세화면을 구현하기 위한 뷰 컴포넌트입니다.
 * - props로 주어진 sections를 콘솔의 디자인과 기획이 적용된 상세 화면을 랜더링합니다.
 *
 * @example
 * <DetailLayout>
 *   <DetailSection>
 *     <DetailView sections={[...]} />
 *   </DetailSection>
 * </DetailLayout>
 */
const DetailView = ({ sections, infoMessage }: DetailViewProps) => {
  const memoizedSectionIds = useMemo(() => {
    return new Array(sections.length).fill(0).map(() => getUuid());
  }, [sections.length]);

  const sectionsWithEntryId = useMemo(() => {
    return sections.map((section, idx) => ({
      ...section,
      entryId: memoizedSectionIds[idx],
    }));
  }, [sections, memoizedSectionIds]);

  return (
    <Fragment>
      <DetailViewTabs sections={sectionsWithEntryId} />
      {infoMessage}
      <DetailViewSectionContainer sections={sectionsWithEntryId} />
    </Fragment>
  );
};

export default DetailView;
